import { ReactElement } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import Tabs from '../controls/Tabs';
import Groups from '../components/Groups';
import Gateways from '../components/Gateways';
import DevicesTab from '../components/DevicesTab';

const TAB_DEVICES = 'devices';
const TAB_GROUPS = 'groups';
const TAB_GATEWAYS = 'gateways';

/**
 * Data component which loads the list of devices and data related to it.
 * @returns - A React element that represents the data component.
 */
export default function DeviceSetupPage(): ReactElement {
  const DATA_PAGE_TABS = [
    { id: TAB_DEVICES, name: 'Devices' },
    { id: TAB_GROUPS, name: 'Groups' },
    { id: TAB_GATEWAYS, name: 'Gateways' }
  ];
  const { state } = useLocation();

  const [params, setParams] = useSearchParams();
  const SEARCH_PARAM_TAB = params.get('tab');
  const SELECTED_TAB = SEARCH_PARAM_TAB || TAB_DEVICES;

  return (
    <>
      <div className="border-b border-b-gray-800">
        <div className="lg:w-1/2">
          <Tabs
            tabs={DATA_PAGE_TABS}
            selectedTab={SELECTED_TAB}
            onTabClick={(selected: string) => setParams({ tab: selected })}
            tabType="full-width"
          />
        </div>
      </div>
      {SELECTED_TAB === TAB_DEVICES && <DevicesTab addNew={state?.addNew} />}
      {SELECTED_TAB === TAB_GROUPS && <Groups />}
      {SELECTED_TAB === TAB_GATEWAYS && <Gateways />}
    </>
  );
}
